import React from 'react';
import { Modal, Button, Dropdown, Divider, TextArea } from 'semantic-ui-react';

function capitalize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

class SelectReasonModal extends React.Component {
  state = { description: undefined };

  setReason = (e, { value }) => this.setState({ reason: value });

  onCancel = () => {
    this.setState({ reason: undefined });
    this.props.hideModal();
  };

  handleDescriptionChange = e => {
    this.setState({ description: e.target.value });
  };

  render() {
    const { operation, options, question } = this.props;

    return (
      <Modal closeOnRootNodeClick={false} open={this.props.open}>
        <Modal.Header>
          {question ? question : `Select a reason for ${operation}`}
        </Modal.Header>
        <Modal.Content>
          <Dropdown
            required
            selection
            options={options}
            placeholder={'Select reason'}
            onChange={this.setReason}
            label={'Reason for ' + operation}
          />
          <Divider hidden />
          {this.props.isDescriptionVisible && (
            <TextArea
              rows={6}
              onChange={this.handleDescriptionChange.bind(this)}
              value={this.state.description}
            />
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={this.onCancel}>
            Cancel
          </Button>
          <Button
            primary
            onClick={() =>
              this.props.handleClose(this.state.reason, this.state.description)
            }
          >
            {capitalize(operation)}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
export default SelectReasonModal;



// WEBPACK FOOTER //
// ./src/component/modals/SelectReasonModal.js